import { useEffect, useState } from 'react';

function ScrollNav() {
  const [showTop, setShowTop] = useState(false);
  const [showBottom, setShowBottom] = useState(true);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      const scrollHeight = document.documentElement.scrollHeight;
      const clientHeight = document.documentElement.clientHeight;

      setShowTop(scrollTop > 300);
      setShowBottom(scrollTop + clientHeight < scrollHeight - 200);
    };

    handleScroll();
    window.addEventListener('scroll', handleScroll, { passive: true });
    window.addEventListener('resize', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleScroll);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const scrollToBottom = () => {
    window.scrollTo({
      top: document.documentElement.scrollHeight,
      behavior: 'smooth',
    });
  };

  if (!showTop && !showBottom) return null;

  return (
    <div className="fixed bottom-6 right-4 md:right-6 z-40 flex flex-col gap-2">
      {showTop && (
        <button
          type="button"
          onClick={scrollToTop}
          aria-label="Remonter en haut"
          title="Remonter en haut"
          className="w-11 h-11 flex items-center justify-center rounded-full bg-background-50 border border-background-300/60 text-foreground-400 hover:text-foreground-50 hover:bg-primary-500 hover:border-primary-500 transition-all duration-300 cursor-pointer"
        >
          <i className="ri-arrow-up-line text-xl" />
        </button>
      )}

      {showBottom && (
        <button
          type="button"
          onClick={scrollToBottom}
          aria-label="Aller en bas"
          title="Aller en bas"
          className="w-11 h-11 flex items-center justify-center rounded-full bg-background-50 border border-background-300/60 text-foreground-400 hover:text-foreground-50 hover:bg-accent-500 hover:border-accent-500 transition-all duration-300 cursor-pointer"
        >
          <i className="ri-arrow-down-line text-xl" />
        </button>
      )}
    </div>
  );
}

export default ScrollNav;